import { colors } from "#app/theme/v1/colors";
import { Icon, IconName } from "#shared/icons/Icon";
import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";
import { formatSingularOrPlural } from "shared";

type Props = {
  count: number;
  label: string;
  icon: IconName;
  unit?: string;
  pluralize?: boolean;
};

export const MaterialProperty = ({ count, label, icon, unit, pluralize = true }: Props) => {
  const propertyLabel =
    count && pluralize
      ? formatSingularOrPlural(count, label, {
          isValueVisible: false,
        })
      : label;

  const countDisplay = count ? `${count} ` : "";

  return (
    <Flex gap="xs" align="center">
      <Icon name={icon} size={16} />
      <Text>
        <Text component="span" fw={600} c={colors.violet[5]}>
          {countDisplay}
        </Text>
        {unit && (
          <Text component="span" style={{ whiteSpace: "pre-line" }}>
            {" " + unit + " "}
          </Text>
        )}
        <Text component="span" style={{ whiteSpace: "pre-line" }}>
          {propertyLabel}
        </Text>
      </Text>
    </Flex>
  );
};
